module.exports = __webpack_public_path__ + "static/media/called_party.3ad4b329.png";